__turbopack_context__.v({
  "bonusDrawerOffset": "header-module-scss-module__ME5lHG__bonusDrawerOffset",
  "btn": "header-module-scss-module__ME5lHG__btn",
  "btn-alt": "header-module-scss-module__ME5lHG__btn-alt",
  "btn-default": "header-module-scss-module__ME5lHG__btn-default",
  "btn-default-dark-bg": "header-module-scss-module__ME5lHG__btn-default-dark-bg",
  "btn-disabled": "header-module-scss-module__ME5lHG__btn-disabled",
  "btn-elite": "header-module-scss-module__ME5lHG__btn-elite",
  "btn-gold": "header-module-scss-module__ME5lHG__btn-gold",
  "btn-lg": "header-module-scss-module__ME5lHG__btn-lg",
  "btn-link": "header-module-scss-module__ME5lHG__btn-link",
  "btn-plat": "header-module-scss-module__ME5lHG__btn-plat",
  "btn-primary": "header-module-scss-module__ME5lHG__btn-primary",
  "btn-sm": "header-module-scss-module__ME5lHG__btn-sm",
  "btn-success": "header-module-scss-module__ME5lHG__btn-success",
  "btn-warning": "header-module-scss-module__ME5lHG__btn-warning",
  "container": "header-module-scss-module__ME5lHG__container",
  "csLogoHereStyles__Placeholder": "header-module-scss-module__ME5lHG__csLogoHereStyles__Placeholder",
  "deltaDefenseLogo": "header-module-scss-module__ME5lHG__deltaDefenseLogo",
  "disabled": "header-module-scss-module__ME5lHG__disabled",
  "header": "header-module-scss-module__ME5lHG__header",
  "light": "header-module-scss-module__ME5lHG__light",
  "supportLink": "header-module-scss-module__ME5lHG__supportLink",
  "tablet": "header-module-scss-module__ME5lHG__tablet",
  "usccaLogo": "header-module-scss-module__ME5lHG__usccaLogo",
});
